// Configuration file for settings
export const config = {
  // Feature flags
  addressLookupEnabled: false,
  
  // Ideal Postcodes API configuration
  idealPostcodes: {
    apiKey: 'ak_mjtdtn6bmxMboMnlL6AM7Mhrvle34',
    enabled: true
  }
};

// Configuration for UW Street Smart campaign tracker
